import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import DocPage from "../components/DocPage.vue";
import { company } from "../company";


export default /*#__PURE__*/_defineComponent({
  __name: 'Security',
  setup(__props) {

const sections = ["where", "who", "identity", "ai", "secrets", "trace", "transit"];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.security.title'),
    lede: _ctx.$t('pages.security.lede')
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (s) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: s }, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(`pages.security.${s}.title`)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(`pages.security.${s}.p1`)), 1)
        ], 64))
      }), 64)),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.security.questions.title")), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("pages.security.questions.p1")) + " ", 1),
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}?subject=Connectera%20security`
        }, _toDisplayString(_unref(company).email), 9, _hoisted_1)
      ])
    ]),
    _: 1
  }, 8, ["title", "lede"]))
}
}

})